{
  "commons": {
    "app": {
      "title": "Noma Claims"
    },
    "country": "Country",
    "claim_status": {
      "CREATED": "CREATED",
      "READY_FOR_VET_ANALYSIS": "READY FOR VET ANALYSIS",
      "MISSING_INFO": "MISSING INFO",
      "PENDING_DATA_REVIEW": "PENDING DATA REVIEW",
      "ON_HOLD": "ON HOLD",
      "VET_ANALYSIS_COMPLETED": "VET ANALYSIS COMPLETED",
      "PENDING_MUNICH_RE": "PENDING MUNICH_RE",
      "CLOSED": "CLOSED",
      "CLOSED_DETAILED": {
        "MANUALLY": "Closed manually",
        "MISSING_INFO": "Closed by missing info",
        "DUPLICATED": "Closed by duplicated claim",
        "ERRONEOUS": "Closed by erroneous claim",
        "PET_PARENT_ASK_TO_CLOSE": "Closed by pet parent request",
        "POLICY_NOT_ACTIVE": "Closed by policy not active"
      },
      "RESOLUTION_COMPLETED": "RESOLUTION COMPLETED",
      "DISBURSEMENT_REGISTERED_IN_PAS": "DISBURSEMENT REGISTERED BY PAS",
      "DISBURSEMENT_ACCEPTED_BY_PAS": "DISBURSEMENT ACCEPTED BY PAS"
    },
    "related_claim_request": {
      "see_claim": "SEE CLAIM",
      "usage_count_one": "{{count}} usage",
      "usage_count_other": "{{count}} usages"
    },
    "parent_card": {
      "title": "Pet Parent Data",
      "iban": "IBAN",
      "email": "Email",
      "error": {
        "email": "Enter a valid email",
        "iban": "Enter a valid Iban"
      }
    },
    "pet": {
      "gender": {
        "female": "Female",
        "male": "Male"
      },
      "policies": {
        "modal": {
          "title": "{{name}}'s policies"
        }
      },
      "claim_requests": {
        "total_one": "{{count}} claim",
        "total_other": "{{count}} claims",
        "open_one": "{{count}} open request",
        "open_other": "{{count}} open requests"
      }
    },
    "notes": "Notes",
    "claim_request_list": {
      "table": {
        "headers": {
          "country": "Country",
          "link": "Link",
          "policyIdentifier": "Policy identifier",
          "creationDate": "Created at",
          "updateDate": "Last update",
          "latestNote": "Latest note",
          "pet": "Pet information",
          "petParentEmail": "Pet parent email"
        },
        "body": {
          "link": "Open the details"
        }
      }
    },
    "close_incident_manually_modal": {
      "title": "Close a claim",
      "close": "Close",
      "cancel": "Cancel",
      "close_manually_confirmation": "Are you sure you want to close this claim?",
      "close_reason": "Close reason",
      "close_template": "Close claim templates",
      "add_note": "Explain the closing reason. Make sure to speak the language of the pet parent 🙏🏼"
    },
    "delete_incident_manually_modal": {
      "title": "Delete a claim",
      "delete": "Delete",
      "cancel": "Cancel",
      "close_manually_confirmation": "Are you sure you want to delete this claim?"
    },
    "duplicate_claim_confirmation_dialog": {
      "title": "Duplicate the claim",
      "duplicate": "Duplicate",
      "cancel": "Cancel",
      "text": "This action will create a new claim with the associated documents and other information, and you will be redirected to it."
    },
    "note_input": {
      "add_note": "Add note",
      "delete": "Delete"
    },
    "timeline": {
      "minutes_ago": "minutes ago",
      "hours_ago": "hours ago",
      "days_ago": "days ago"
    },
    "value": {
      "unknown": "Unknown"
    },
    "inbox": {
      "add": "Create new",
      "add_detail": "Create a new claim request",
      "search": "Search",
      "search_detail": "Search by policy number",
      "input_policy_label": "Policy number"
    },
    "inbox_item": {
      "manage": "Manage"
    },
    "inbox_page": {
      "page_title": "Claims Management",
      "new_incident": "New Claim",
      "fast_claim": "Fast Claim",
      "new_document": "New Document",
      "vet_assessment": "Vet Assessment",
      "on_hold": "On Hold",
      "see_list": "See list",
      "prevention_with_new_documentation": "Prevention with new documentation",
      "new_prevention": "New Prevention Claims",
      "filtered_by_country": "Filtered by Country",
      "all_countries": "All Countries"
    },
    "incident_notes": {
      "notes": "Notes",
      "tag": "Tag",
      "no_notes": "No notes yet",
      "internal_note": "Internal",
      "internal_note_placeholder": "Add an internal note",
      "tag_note_placeholder": "Add a tag",
      "pet_parent_note": "Pet Parent",
      "pet_parent_note_placeholder": "Add a note for the pet parent. Make sure to speak their language 🙏🏼",
      "fraud": "Fraud",
      "fraud_note_placeholder": "Enter details of possible fraud here",
      "read-only": {
        "no-notes": "There are no notes"
      }
    },
    "missing_info": {
      "title": "Change the status of the claim",
      "question": "Are some information missing?",
      "option": {
        "yes": "Yes",
        "no": "No"
      },
      "select_document": "Select a document",
      "select_issue": "Select an issue",
      "anything_else": "Any other issue?",
      "write_your_own_template": "Write your own template",
      "add_template_manually": "Add template manually",
      "type": {
        "CLINICAL_HISTORY": "Clinical History",
        "INVOICE": "Invoice",
        "VET_REPORT": "Vet Report",
        "MEDICAL_IMAGING": "Medical Imaging",
        "MEDICAL_ANALYTIC": "Medical Analytic",
        "ADMINISTRATIVE_DOCUMENTATION": "Administrative Documentation",
        "VACCINATION_CARD": "Vaccination Card",
        "OTHER": "Other",
        "PAYMENT_LETTER": "Payment letter",
        "VET_FORM": "Vet Form"
      },
      "add_another_category": "Request another document",
      "add_note": "Add a note. Make sure to speak the language of the pet parent 🙏🏼",
      "note_label": "Note",
      "templates": "Missing Info Templates",
      "save": "Save",
      "save_description": "Save status of the claim",
      "preview_title": "Note",
      "allow_automation_label": "Allow automation to take over when new documents arrive"
    },
    "template_input": {
      "from": "from",
      "to": "to",
      "add": "Add",
      "delete": "Delete"
    },
    "preview_modal": {
      "title": "Petparent preview",
      "save": "Send",
      "save_description": "Send the missing info message to the pet parent"
    },

    "request_header": {
      "title": "Claim from {{date}}",
      "view_previous": "View previous",
      "reserved_by": "Reserved by {{userName}}",
      "not_reserved": "Not reserved",
      "steal_reservation": "Steal reservation",
      "notes": "Notes {{notesCount}}",
      "notes_accesibility": "Create or view notes",
      "barkibu_card": {
        "chip_name": "Barkibu Card 💳",
        "chip_click": "Click to copy to clipboard expense id: {{ prepaidExpenses }}"
      }
    },
    "note_option": {
      "internal_note": "Internal Note",
      "internal_note_placeholder": "Add an internal note",
      "fraud": "Fraud",
      "fraud_note_placeholder": "Enter details of possible fraud here",
      "tag": "Tag",
      "tag_note_placeholder": "Add a tag"
    },
    "note_scope_option": {
      "policy": "Policy",
      "policy_placeholder": "This note will be related to the Policy.",
      "pet_parent": "Pet Parent",
      "pet_parent_placeholder": "This note will be related to the Pet Parent.",
      "pet": "Pet",
      "pet_placeholder": "This note will be related to the Pet."
    },
    "modal": {
      "close": "Close",
      "continue": "Continue",
      "cancel": "Cancel"
    },
    "cause_of_loss": {
      "label": "Origin of the problem",
      "type": {
        "veterinary": "Veterinary Expenses",
        "non_veterinary": "Non-veterinary Expenses",
        "ACCIDENT": "Accident",
        "DISEASE": "Disease",
        "OTHER": "Other",
        "LOST_PET_ADVERTISING": "Lost pet advertising",
        "LOST_PET_REWARD": "Lost pet reward",
        "HOSPITAL_ACCOMMODATION": "Hospital accommodation",
        "LOSS_DOCUMENTS_ABROAD": "Loss documents abroad",
        "SACRIFICE_AND_INCINERATION_EXPENSES": "Sacrifice and incineration expenses",
        "UNKNOWN": "Unknown"
      }
    },
    "policy": {
      "number": "Policy Number",
      "health": {
        "name": "Health Policy"
      },
      "gl_basic": {
        "name": "General Liability Basic Policy"
      },
      "gl_extended": {
        "name": "General Liability Extended Policy"
      },
      "prevention": {
        "name": "Prevention Policy"
      },
      "platinum": {
        "name": "Platinum Policy"
      },
      "active": "active",
      "suspended": "suspended",
      "closed": "closed",
      "cancelled": "cancelled",
      "not_found": "Policy Not Found",
      "started_on": "Started on {{ startDate }}",
      "active_on": "Active on {{startDate }}",
      "expires_on": "Expires on {{ expirationDate }}",
      "expires_on_with_covered_until": "Expires on {{ expirationDate }} \nCovered until {{ coveredUntil }}",
      "also_available": "Also available:",
      "invoice_date_outside_coverage": "Invoice date is outside the covered period",
      "some_invoice_dates_outside_coverage": "Some invoice dates are outside the covered period",
      "non_renewal_requested": "non-renewal requested",
      "claim_requests": "Claim requests for the Pet",
      "contract": {
        "v2": {
          "alert": "This policy has a Spanish V2 contract that <br /> starts at <bold>{{startDate}}</bold> and ends at <bold>{{expirationDate}}</bold>"
        }
      },
      "fraud": {
        "alert": "Another claim request has been flagged as potentially fraudulent"
      }
    },
    "preview_file": {
      "unsupported": "File unsupported 😢"
    },
    "selector": {
      "no_elements": "No elements"
    },
    "dropdown": {
      "no_data": "No data"
    },
    "clinical_history": {
      "title": "Clinical history",
      "view_clinical_history": "View clinical history",
      "complete": "Complete",
      "incomplete": "Incomplete",
      "no_preexisting_conditions": "NO PRE-EXISTING CONDITIONS",
      "note_label": "Comments",
      "validation": {
        "title": "Document {{current}} of {{totalCount}}",
        "no_documents": "The policy doesn't have clinical history documents 🥲",
        "banner": "Clinical history validation",
        "go_to_previous": "Go to Previous Document",
        "go_to_next": "Go to Next Document",
        "preexistent_disease_label": "Pre-existing conditions",
        "addition_label": "Add disease",
        "validation_label": "Content",
        "note_label": "Comments",
        "no_note_label": "Add comments"
      },
      "previous_claims": {
        "title": "Previous claims",
        "no_claims": "No previous claims on this policy.",
        "no_summary": "No claim summary yet."
      }
    },
    "claim_details": {
      "details": "Details",
      "visit_reason": "Reason of the visit"
    },
    "claim_lifecycle": {
      "status": "Claim status",
      "bind_referral_approval": "Bind Referral"
    },
    "referral_approval_modal": {
      "title": "Bind Referral Approval",
      "description": "Upload a document (optional) and execute the referral approval.",
      "upload_document": "Upload Document",
      "optional": "(optional)",
      "cancel": "Cancel",
      "execute": "Execute"
    }
  },
  "dataentry": {
    "supporting_documents": {
      "title": "Documents"
    },
    "policy": {
      "number": "Policy Number",
      "health": {
        "name": "Health Policy"
      },
      "gl_basic": {
        "name": "General Liability Basic Policy"
      },
      "gl_extended": {
        "name": "General Liability Extended Policy"
      },
      "prevention": {
        "name": "Prevention Policy"
      },
      "active": "active",
      "non_active": "non active",
      "not_found": "Policy Not Found",
      "started_on": "Started on {{ startDate }}",
      "expires_on": "Expires on {{ expirationDate }}",
      "claim_requests": "Claim requests for the Pet",
      "reserved_by": "Reserved by {{userName}}",
      "not_reserved": "Not reserved",
      "no_summary": "No claim summary yet."
    },
    "incident": {
      "of": "{{petName}}'s claim",
      "save": "Save Changes",
      "continue": "Go to Cost Lines",
      "continue_skipping_invoices": "Continue",
      "review_cost_lines": "Review Cost Lines",
      "mark_as_missing_info": "Mark as Missing Info",
      "mark_as_on_hold": "Mark as on Hold",
      "duplicate_claim": "Duplicate claim",
      "other_actions": "Other actions",
      "delete_incident": "Delete Claim",
      "close_incident": "Close Claim",
      "origin_date": "Origin",
      "request_date": "Request",
      "dates": "Dates",
      "notes": "Notes",
      "description": "Description",
      "add_note": "Add a note",
      "documents": "Documents of the Request",
      "document": {
        "add": "Add a document",
        "save": "Save",
        "add_modal_title": "Add document to the request",
        "upload": "Upload the document",
        "file": "File",
        "date": "Date",
        "type": "Document Type",
        "edit": "Edit the document",
        "detail": {
          "title": "Document detail",
          "non_value": "Non Value",
          "score": "Score {{score}}%",
          "vet_report": {
            "visit_reason": "Visit reason",
            "present_symptoms": "Present symptoms",
            "date_onset_symptoms": "Date onset symptom",
            "review_date": "Review date",
            "diagnostic_tests_performed": "Diagnostic tests performed",
            "diagnoses": "Diagnoses",
            "treatments": "Treatments"
          }
        },
        "delete": "Delete the document",
        "delete_new": "Delete the new tag from document",
        "name": "Name",
        "edit_name": "Edit the name of the document",
        "edit_type": "Select the type of document",
        "deletion_modal": {
          "title": "Delete a document",
          "delete": "Delete",
          "cancel": "Cancel",
          "delete_confirmation": "Are you sure you want to delete this file? This action is not revertible"
        },
        "missing": "Missing {{type}}"
      },
      "error": {
        "create_claim_from_incident": "Error creating a claim from the claim",
        "close_incident": "Error closing a claim",
        "delete_incident": "Error deleting a claim",
        "email": "Enter a valid Email before send a notification",
        "iban": "Enter a valid Iban before continue",
        "date_of_loss": "Enter a valid date of loss before continue"
      }
    },
    "invoice": {
      "title": "Invoice {{current}} of {{totalCount}}",
      "document_title": "Document {{current}} of {{totalCount}}",
      "position_in_document": "Invoice {{current}} of {{totalCount}} in this document",
      "update_successful": "Invoice updated successfully",
      "persist_error": "Error updating the invoice",
      "missing_cost_lines": "An invoice has no associated cost line, please review that each invoice is saved",
      "move_to_vet_view_error": "Error moving the claim to the vet view",
      "nothing_to_digitise": "No invoice to digitise",
      "confirm_exit_with_changes": "There are changes without saving, if you change document they will be lost, Do you want to continue?",
      "save_changes": "Save Changes",
      "go_to_previous": "Go to Previous Invoice",
      "go_to_next": "Go to Next Invoice",
      "go_to_previous_document": "Go to Previous Document",
      "go_to_next_document": "Go to Next Document",
      "delete": "Delete this invoice",
      "delete_confirmation": "Delete this invoice? The supporting document and any sibling invoices will be kept.",
      "delete_error": "Error deleting the invoice",
      "number": "Invoice Number",
      "date": "Invoice Date",
      "cif": "Tax Id Number",
      "cost_line": {
        "concept": "Concept",
        "quantity": "Quantity",
        "vat": "VAT",
        "retail_price": "Retail Price",
        "add": "Add a Cost Line"
      },
      "cost_lines": "Cost lines",
      "totals": "Totals",
      "clinic": "Clinic",
      "discount": "Discount",
      "total_requested": "Total Requested",
      "total_payable": "Payable Total",
      "continue": "Continue",
      "let_continue": "Let the vets continue",
      "continue_myself": "Continue myself",
      "duplicated": {
        "description": "Duplicated invoice",
        "related_claims": "Claims with duplicated invoices"
      },
      "external_review": {
        "tag": "Reviewed by {{source}}"
      }
    },
    "document": {
      "visualisation_error": "Error viewing the document",
      "download_error": "Error downloading the document",
      "type": {
        "CLINICAL_HISTORY": "Clinical History",
        "INVOICE": "Invoice",
        "VET_REPORT": "Vet Report",
        "MEDICAL_IMAGING": "Medical Imaging",
        "MEDICAL_ANALYTIC": "Medical Analytic",
        "ADMINISTRATIVE_DOCUMENTATION": "Administrative Documentation",
        "VACCINATION_CARD": "Vaccination Card",
        "OTHER": "Other",
        "PAYMENT_LETTER": "Payment letter",
        "NOT_AN_INVOICE": "Not an invoice",
        "TREATMENT_INSTRUCTIONS": "Treatment instructions",
        "PHOTOS": "Photos",
        "CLIENT_NOTES": "Client notes",
        "INVOICE_WITH_MORE_THAN_ONE_PAGE": "Invoice with more than one page",
        "VET_FORM": "Vet form"
      },
      "other_details": {
        "title": "What is wrong with this document?",
        "confirm": "Move to \"Other\""
      },
      "deletion_modal": {
        "title": "What's wrong with this document?",
        "reason": {
          "NOT_RELEVANT": "not relevant",
          "ILLEGIBLE": "illegible",
          "DUPLICATED_IN_CLAIM": "duplicated in this claim",
          "DUPLICATED_IN_OTHER_CLAIM": "duplicated in other claim",
          "OTHER": "other"
        },
        "confirm": "Delete permanently"
      }
    }
  },
  "veterinaryanalysis": {
    "assessment": {
      "request": "Request",
      "go_to_cost_lines": "Go to Cost Lines",
      "other_actions": "Other actions",
      "mark_as_missing_info": "Mark as Missing Info",
      "go_back_to_dataentry": "Go back to Dataentry",
      "error_syncing": "Error syncing data. Please reload the page",
      "not_initialised": "The Assessment is not properly initialised, check the Dataentry",
      "dates": "Dates",
      "invoice": "Invoice",
      "first_symptoms": "First Symptoms",
      "symptoms": "Symptoms",
      "add_symptom": "Add symptom",
      "no_symptom_selected": "No symptom selected",
      "diagnoses": "Diagnoses",
      "internal_diagnosis": "Internal",
      "external_diagnosis": "External",
      "add_internal_diagnosis": "Add internal Diagnosis",
      "add_external_diagnosis": "Add external Diagnosis",
      "no_diagnosis_selected": "No diagnosis selected",
      "duplicate_claim": "Duplicate claim"
    },
    "coverages": {
      "back_to_vet_view": "Go back to the assessment",
      "back_to_invoice_digitisation": "Go back to invoice digitisation",
      "select_coverages": "Select the coverages for the following items",
      "concept": "Concept",
      "amount": "Amount",
      "coverage": "Coverage",
      "reason": "Reason",
      "reimbursable_total": "Reimbursable total",
      "see_claim": "See claim",
      "finalise_review": "Finalise Review",
      "error": {
        "sync_fail": "Error syncing data. Please reload the page"
      },
      "warning": {
        "pre_existence": "Pre-existence",
        "duplicated_invoice": "Duplicated invoice",
        "waiting_period": "Waiting period"
      },
      "dialog_title": "Coverage usage {{usage}}"
    },
    "pet_parent_message": {
      "title": "Message to the pet parent",
      "label": "Message",
      "templates": "Templates",
      "placeholder": "Include resolution message for the pet parent.Make sure to speak their language \uD83D\uDE4F\uD83C\uDFFC",
      "save": "Confirm resolution with pet parent note",
      "save_description": "Confirm resolution with pet parent note"
    }
  },
  "claim_info": {
    "total_reimbursable": "Total payable",
    "summary_view": {
      "diagnoses": "Diagnoses",
      "symptoms": "Symptoms",
      "claim_from": "Claim from",
      "dates": "Dates",
      "origin": "Origin",
      "billable-concept": {
        "recommendation": {
          "not_reviewed": "Not reviewed"
        }
      },
      "overturn_vet_decision": "Overturn Decision",
      "review": "Review",
      "duplicate_claim": "Duplicate claim",
      "claim_summary": {
        "title": "Claim summary",
        "empty": "No claim summary yet.",
        "edit": "Edit",
        "save": "Save",
        "cancel": "Cancel",
        "placeholder": "Write the claim summary…",
        "save_error": "Could not save the claim summary. Please try again.",
        "audience": {
          "VETERINARY": "Veterinary",
          "CUSTOMER_CARE": "Customer care"
        }
      }
    }
  }
}
